module.exports = __webpack_public_path__ + "94ea3733cac36593c8b7aa5c72baa051.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/face/mask-snorkel-s.png
// module id = 1859
// module chunks = 0